"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountIdentityRelation = exports.AccountKeyType = void 0;
/**
 * Distinguishes MultiSig and Smart Contract accounts
 */
var AccountKeyType;
(function (AccountKeyType) {
    /**
     * Account is a standard type (e.g. corresponds to the public key of a sr25519 pair)
     */
    AccountKeyType["Normal"] = "";
    /**
     * Account is a MultiSig. (i.e. multiple signatures are required to authorize transactions)
     */
    AccountKeyType["MultiSig"] = "MultiSig";
    /**
     * Account represents a smart contract
     */
    AccountKeyType["SmartContract"] = "SmartContract";
})(AccountKeyType = exports.AccountKeyType || (exports.AccountKeyType = {}));
/**
 * Represents the how an Account is associated to an Identity
 */
var AccountIdentityRelation;
(function (AccountIdentityRelation) {
    /**
     * The Account is not associated to any Identity
     */
    AccountIdentityRelation["Unassigned"] = "Unassigned";
    /**
     * The Account is the Identity's primary key (i.e. it has full permission)
     */
    AccountIdentityRelation["Primary"] = "Primary";
    /**
     * The Account is a Secondary account. There are associated permissions that may limit what transactions it may authorize for the Identity
     */
    AccountIdentityRelation["Secondary"] = "Secondary";
    /**
     * The Account is one of many signers for a MultiSig
     */
    AccountIdentityRelation["MultiSigSigner"] = "MultiSigSigner";
})(AccountIdentityRelation = exports.AccountIdentityRelation || (exports.AccountIdentityRelation = {}));
//# sourceMappingURL=types.js.map